import moment from "moment";
import CTA from "../Constants";
export default function appReducer(state, action) {
    switch (action.type) {
        case CTA.SET_LOADER:
            const isLoading = action.payload.isLoading;
            const loaderHash = action.payload.loaderHash;
            const newState = { ...state };
            const loaders = newState.loaders || {};
            let newIsLoading;
            if (isLoading) {
                loaders[loaderHash] = true;
                newIsLoading = true;
            } else {
                loaders[loaderHash] = false;
                newIsLoading = Object.values(loaders).some((e) => e);
            }
            newState.loaders = loaders;
            return {
                ...newState,
                isLoading: newIsLoading,
            };
        case CTA.SET_CHATS_LOADER:
            return {
                ...state,
                chatsAreLoading: action.payload.isLoading,
            };
        case CTA.SET_AUTH:
            return {
                ...state,
                isAuthenticated: action.payload.isAuthenticated,
                agent: action.payload.agent,
            };
        case CTA.SET_AGENT:
            return {
                ...state,
                agent: action.payload.agent,
            };
        case CTA.SET_CHATS:
            return {
                ...state,
                chats: action.payload.chats,
            };
        case CTA.SET_CHATS_LIST_FILTERS:
            return {
                ...state,
                chatsListFilters: action.payload.chatsListFilters,
            };
        case CTA.SET_SELECTED_CHAT:
            return {
                ...state,
                selectedChat: action.payload.selectedChat,
            };
        case CTA.SET_SELECTED_CHAT_HISTORY:
            return {
                ...state,
                selectedChathistory: action.payload.selectedChatHistory,
            };
        case CTA.SET_CHAT_OWNER:
            const editList = JSON.parse(JSON.stringify(state.chats));
            editList.forEach((item) => {
                if (item.id === action.payload.chat.id) {
                    if (action.payload.owner === "ME") {
                        item.ownedBy = { ...state.agent, isCurrentUser: true };
                    } else {
                        delete item.ownedBy;
                    }
                }
            });
            return {
                ...state,
                chats: editList,
            };
        case CTA.SET_CLOSED_CHAT:
            return {
                ...state,
                chats: state.chats.filter((item) => item.id !== action.payload.chat.id),
            };
        case CTA.UPDATE_CHAT:
            const chats = state.chats.map((item) => {
                if (item.id === action.payload.chat.id) {
                    item = action.payload.chat;
                }
                return item;
            });
            return {
                ...state,
                chats: chats,
            };
        case CTA.UPDATE_CHAT_SEEN:
            return {
                ...state,
                chats: state.chats.map((item) => {
                    if (item.id === action.payload.chat.id) {
                        item.amountNew = 0;
                    }
                    return item;
                }),
            };
        case CTA.ADD_OR_UPDATE_CHAT:
            const newList = JSON.parse(JSON.stringify(state.chats));
            let selected = newList.find((item) => item.id === action.payload.chat.id);
            if (selected) {
                newList.splice(newList.indexOf(selected), 1, action.payload.chat);
                return {
                    ...state,
                    chats: newList,
                };
            }
            newList.unshift(action.payload.chat);
            return {
                ...state,
                chats: newList,
            };
        case CTA.UPDATE_CUSTOMER_INFO:
            return {
                ...state,
                chats: state.chats.map((item) => {
                    if (item.id === action.payload.chat.id) {
                        item.customer = action.payload.customer;
                    }
                    return item;
                }),
            };
        case CTA.SET_LIKED_ANSWER:
            return {
                ...state,
                likedAnswer: action.payload.answer,
            };
        case CTA.SET_NEW_CHAT_NOTIFICATION:
            return {
                ...state,
                newChats: action.payload.newChats,
            };
        case CTA.SET_CHAT_OWNER_BUTTON:
            return {
                ...state,
                chatOwnerButton: action.payload.chatOwnerButton,
            };
        case CTA.SET_CURRENT_CHAT_OPTION:
            return {
                ...state,
                currentChatOption: {
                    selectedChatId: action.payload.chatSelectedId,
                    action: action.payload.currentChatOption,
                },
            };
        case CTA.SET_WORKSPACE_CONFIG:
            return {
                ...state,
                workspaceConfig: action.payload.workspaceConfig,
            };
        case CTA.SET_CONVERSATION_LABELS:
            return {
                ...state,
                conversationLabels: action.payload.conversationLabels,
            };
        case CTA.SET_CONVERSATION_TAG_GROUPS:
            return {
                ...state,
                conversationTagGroups: action.payload.conversationTagGroups,
            };
        case CTA.SET_CHAT_SOCKET_STATUS:
            return {
                ...state,
                chatSocketStatus: action.payload.chatSocketStatus,
            };
        case CTA.SET_NOTIFICATION_SOCKET_STATUS:
            return {
                ...state,
                notificationSocketStatus: action.payload.notificationSocketStatus,
            };
        case CTA.MARK_READ:
            return {
                ...state,
                chats: state.chats.map((chat) => {
                    if (chat.id === action.payload.chat.id) {
                        const newChat = { ...chat };
                        delete newChat.startedWaitingOn;
                        return newChat;
                    }
                    return chat;
                }),
            };
        case CTA.MARK_UNREAD:
            return {
                ...state,
                chats: state.chats.map((chat) => {
                    if (chat.id === action.payload.chat.id) {
                        const newChat = { ...chat };
                        newChat.startedWaitingOn = moment().toISOString();
                        return newChat;
                    }
                    return chat;
                }),
            };
        case CTA.SET_WORKSPACE_NAME:
            if (!action.payload.workspaceName) return { ...state };
            return {
                ...state,
                workspaceName: action.payload.workspaceName,
            };
        case CTA.SET_AGENT_STATE:
            const newAgentState = { ...state };
            if (newAgentState.agent) {
                newAgentState.agent.agentState = action.payload.agentState;
            }
            return newAgentState;
        case CTA.SET_DEEP_LINK_CHAT_STATE:
            const found = action.payload.deepLinkChatState?.found;
            const chatId = action.payload.deepLinkChatState?.chatId;

            if (found === undefined && chatId === undefined) {
                return { ...state, deepLinkChatState: undefined };
            }

            const stateDeepLink = {
                ...state,
                deepLinkChatState: {
                    found: found,
                    chatId: chatId,
                },
            };
            return stateDeepLink;
        default:
            return state;
    }
}
